var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('table',{attrs:{"id":"carTable"}},[_c('thead'),_c('tbody',{style:({'height':_vm.height}),attrs:{"id":"carTbo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }